import type { Language } from "@/contexts/LanguageContext";

/**
 * Os numeros do perfil do Google do escritorio, em um lugar so.
 *
 * Antes de 20/10/2026 eles estavam espalhados: "191" em seis chaves de i18n
 * (njlp.rating.reviews e famlp.rating.reviews nos tres idiomas) mais uma
 * constante dentro da LP de Queens, e "4.8" escrito a mao em tres arquivos.
 * Sete lugares para um numero que muda sozinho a cada avaliacao nova — e que
 * ja estava divergindo: a LP de Queens mostrava cinco estrelas cheias sem
 * numero nenhum, afirmando 5,0 numa casa que tem 4,8.
 *
 * Mudar a nota agora e mudar aqui.
 */
export const GOOGLE_RATING = 4.8;
export const GOOGLE_REVIEW_COUNT = 191;

/** Quanto da fileira de cinco estrelas fica pintada: 4,8 de 5 = 96%. */
export const RATING_PERCENT = (GOOGLE_RATING / 5) * 100;

const NUMBER_LOCALE: Record<Language, string> = {
  EN: "en-US",
  PT: "pt-BR",
  ES: "es-US",
};

/**
 * "4.8" em ingles, "4,8" em portugues e espanhol. Separador decimal errado
 * num numero que e prova social parece erro de digitacao, nao arredondamento.
 */
export const formatRating = (language: Language): string =>
  new Intl.NumberFormat(NUMBER_LOCALE[language], {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(GOOGLE_RATING);

/** "191 Google reviews", "191 avaliações no Google", "191 reseñas en Google". */
export const reviewCountLabel = (t: (key: string) => string): string =>
  `${GOOGLE_REVIEW_COUNT} ${t("reviews.countSuffix")}`;
